module.exports = __webpack_public_path__ + "img/corona_small.0a0ee743.jpg";